export default {
  setChannelData(state, data) {
    state.channelData = data;
  },
  setChannelsList(state, data) {
    state.channelsList = data;
  },
};
